import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/clCommunityData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20modern%20creative%20community%20hub%20with%20warm%20orange%20and%20teal%20accent%20colors%20abstract%20geometric%20patterns%20flowing%20connections%20digital%20network%20visualization%20soft%20gradient%20overlay%20clean%20modern%20aesthetic%20atmospheric%20lighting%20high%20quality%20editorial%20style&width=1600&height=900&seq=hero-bg-community&orientation=landscape"
          alt="CL社区首页"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-4 leading-tight">
          {siteInfo.name}
        </h1>
        <p className="text-base md:text-xl text-white/85 mb-3 max-w-2xl mx-auto leading-relaxed">
          {siteInfo.tagline}
        </p>
        <p className="text-sm md:text-base text-white/65 mb-8 max-w-xl mx-auto leading-relaxed">
          发现优质内容，连接活跃圈子。超过 {siteInfo.members} 用户选择的在线交流平台，一起探索知识的无限可能。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/tech-discussion"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            探索社区
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-white/15 backdrop-blur-sm text-white font-medium rounded-lg hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm border border-white/20"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}